/**
 * 集中的药物名称映射
 *
 * 所有需要药物英文→中文翻译的地方统一引用此模块,
 * 避免在 CaseList / CaseHistory / ReportPreview / AdminPanel / TenantStats / AgentAnalysisTab 等
 * 多处重复定义翻译字典。
 */

/** 药物名称中文映射 (静态 fallback) */
export const DRUG_NAME_MAP: Record<string, string> = {
  vancomycin: '万古霉素',
  meropenem: '美罗培南',
  voriconazole: '伏立康唑',
  linezolid: '利奈唑胺',
};

/** 获取药物中文显示名 */
export function getDrugLabel(drugName: string | undefined | null, fallback = '药物'): string {
  if (!drugName) return fallback;
  return DRUG_NAME_MAP[drugName.toLowerCase()] || drugName;
}

/** 计算类型中文映射 */
export const CALC_TYPE_LABELS: Record<string, string> = {
  initial: '初始剂量',
  optimize: '剂量优化',
  pk_formula: 'PK公式法',
};

/** 获取药物选项列表 (用于 Select 组件) */
export function getDrugOptions() {
  return Object.entries(DRUG_NAME_MAP).map(([value, label]) => ({ value, label }));
}
